type ProductExtraEnrichmentField = { key: string; alias?: string };

const PRODUCT_EXTRA_ENRICHMENT_FIELDS: ProductExtraEnrichmentField[] = [
  { key: 'builderId' },
  { key: 'agentId' },
  { key: 'type' },
  { alias: 'hitUrl', key: 'url' },
  { alias: 'creativeTitle', key: 'title' },
  { alias: 'creativeText', key: 'description' },
  { key: 'label' },
];

export function getJsonFields(parsedDecodedParams: Record<string, string>): Record<string, string> {
  const jsonFields = PRODUCT_EXTRA_ENRICHMENT_FIELDS.reduce<Record<string, string>>((acc, el) => {
    const value = parsedDecodedParams[el.key];

    if (value !== '' && value != null) {
      acc[el.alias || el.key] = value;
    }

    return acc;
  }, {});

  if (parsedDecodedParams.objectId) {
    jsonFields.dealType = parsedDecodedParams.dealType || 'sale';
    jsonFields.objectType = parsedDecodedParams.objectType || 'jk';
    jsonFields.objectId = parsedDecodedParams.objectId;
  }

  return jsonFields;
}
